import { useMutation } from "urql";

import { CreateCreditApprovalDocument } from "../../../graphql/generated.ts";

export const useCreateCreditApproval = () => {
  return useMutation(CreateCreditApprovalDocument);
};
